import { useMemo } from 'react';
import { useRestQuery } from 'utils/hooks/api';
import { isEmptyString } from 'utils/stringHelpers';
import { getCatalogFieldMappingsUrl } from 'api/CatalogAPI';
import { MappingMetadata } from './types';
import { useCatalogName } from '../../useCatalogName';
import { ClientDataType, ESIndex, FieldType } from '../../../types';
import { useQueryStateContext } from '../../../contexts';
import { useMappingIdCache } from './useMappingIdCache';

type CatalogFieldMappings = {
  definedMappings?: Record<string, FieldType>;
  undefinedFields: string[];
};

export const useCatalogFieldMappings = () => {
  const { esIndex } = useQueryStateContext();
  const catalogName = useCatalogName();
  const { getIdForMapping } = useMappingIdCache();
  const {
    data: { definedMappings = {} } = {},
    isLoading,
    isError,
  } = useRestQuery<CatalogFieldMappings>(
    getCatalogFieldMappingsUrl(catalogName),
    {},
    {
      enabled: !isEmptyString(catalogName) && esIndex === ESIndex.Catalog,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );

  const mappings: MappingMetadata[] = useMemo(() => {
    return Object.entries(definedMappings).map(([name, fieldType]) => ({
      id: getIdForMapping(ClientDataType.User, name),
      name,
      fieldType,
      dataType: ClientDataType.User,
    }));
  }, [definedMappings]);

  return {
    mappings,
    isLoading,
    didError: isError,
  };
};
